var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item Icon",
    clipPath: "url(#clip0_4449_175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.115671 6.1228L7.67219 14.8483C7.75615 14.9448 7.87481 15 7.99901 15C8.12321 15 8.24188 14.9448 8.32583 14.8483L15.8823 6.1228C16.026 5.95709 16.0399 5.70671 15.9143 5.52479L12.925 1.18853C12.841 1.06996 12.7092 1 12.5697 1H3.43186C3.29239 1 3.16055 1.06996 3.07658 1.18853L0.0873007 5.52479C-0.0389889 5.70596 -0.0272719 5.95636 0.115671 6.1228ZM11.293 6.27524H14.5439L9.17323 12.4763L11.293 6.27524ZM7.99904 13.1478L5.65086 6.27524H10.3472L7.99904 13.1478ZM7.99904 2.26006L10.1092 5.33333L5.88889 5.3326L7.99904 2.26006ZM5.15685 4.80299L4.19927 1.93013H7.12674L5.15685 4.80299ZM8.87125 1.93013H11.7987L10.8411 4.80299L8.87125 1.93013ZM4.70369 6.26638L6.82291 12.4687L1.45488 6.27505L4.70369 6.26638ZM14.6798 5.32372H11.6086L12.6085 2.30719L14.6798 5.32372ZM3.38047 2.32416L4.38037 5.34069H1.31826L3.38047 2.32416Z",
    fill: "#767A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4449_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionIcon3);
export default __webpack_public_path__ + "static/media/solution_icon_3.d6b83a9581e86035a96781445a6af5c1.svg";
export { ForwardRef as ReactComponent };